/**
 * react-select grouped options for the wizard's product dropdown.
 *
 * Managed products appear first under a label that says what picking one
 * does, so a 30-second reach into the customer's ServiceNow is never a
 * surprise. Options carry managedProductId; the wizard uses its presence to
 * decide between the scan flow and the existing manual flow.
 */
/**
 * Whether a vendor can run a live inventory scan.
 *
 * `inventoryVendors` is the backend's list (GET /bsa/inventory/vendors, the
 * adapter registry). null/undefined means "not loaded or unavailable", which
 * answers false on purpose: offering a scan that cannot run is the failure
 * this exists to prevent, and the manual "All products" flow is always there.
 * No vendor name lives here — the list is data (STRY0038603).
 */
export function scanCapable(vendorId, inventoryVendors) {
  if (!vendorId || !Array.isArray(inventoryVendors)) return false;
  return inventoryVendors.includes(vendorId);
}

/**
 * `canScan` false hides the inventory group entirely (the vendor has no
 * adapter, or the list has not loaded): managed products still exist for the
 * vendor, but picking one would promise a scan we cannot deliver.
 */
export function buildProductGroups(managedProducts, productOptions, canScan = true) {
  const inventory = (canScan ? managedProducts || [] : [])
    .filter(mp => !mp.isDisabled)
    .map(mp => ({ value: `mp:${mp.id}`, label: mp.name, managedProductId: mp.id }));

  const groups = [];
  if (inventory.length) {
    groups.push({ label: 'Your inventory · scans ServiceNow for live versions', options: inventory });
  }
  groups.push({ label: 'All products', options: productOptions || [] });
  return groups;
}
